import isArray from 'lodash/isArray'
import isObject from 'lodash/isObject'
import _union from 'lodash/union'
import _each from 'lodash/each'
import _keys from 'lodash/keys'
import _pick from 'lodash/pick'

function makePrefix(prefix, property) {
  return prefix ? `${prefix}.${property}` : property
}

function removeOperation(prefix, property) {
  return {
    operation: 'remove',
    property: makePrefix(prefix, property),
  }
}

function setOperation(prefix, property, value) {
  return {
    operation: 'set',
    property: makePrefix(prefix, property),
    value: value,
  }
}

/**
 * Diffs `obj` and `initialObj` and returns a list of patch operations
 * required to update the existing object to the new values.
 *
 * @param obj the "new" object
 * @param initialObj the initial value of the object
 * @param prefix the key prefix for nested operations
 * @returns {Array} a list of patch operations
 */
function patch(obj, initialObj, prefix) {
  let ops = []
  const keys = _union(_keys(obj), _keys(initialObj))
  _each(keys, key => {
    const value = obj[key]
    const isValueObject = isObject(value) && !isArray(value)

    // null-ish values are transformed into "remove" operations
    if (value == null && value != initialObj[key]) {
      ops.push(removeOperation(prefix, key))
    } else if (value != null && !isValueObject && value !== initialObj[key]) {
      // non-object values (including arrays) are transformed into "set" operations
      ops.push(setOperation(prefix, key, value))
    } else if (isValueObject) {
      // object values are traversed, appending the key to the current prefix
      ops = ops.concat(patch(value, initialObj[key] || {}, makePrefix(prefix, key)))
    }
  })
  return ops
}

function _patchOperations(obj, initialObj, prefix) {
  return patch(obj, initialObj || {}, prefix || '')
}

export function patchOperations(obj, initialObj, prefix) {
  const normalizedOldObj = _pick(initialObj, _keys(obj))
  return _patchOperations(obj, normalizedOldObj, prefix)
}



// WEBPACK FOOTER //
// ./src/scripts/utils/PatchHelper.js